export const ADD_ITEM = 'add_item';
export const ACTIVE_ITEM = 'active_element';
export const RE_POSITION = 're_position';
export const REMOVE_ITEM = 'remove_item';
export const NEW_PAGE = 'new_page';
export const CREATE_PAGE = 'create_page';
export const CHANGE_COLUMN = 'change_column';
export const UPDATE_COLUMN_ORDER = 'update_column';
export const SET_PROPERTY = 'set_property';
export const INIT_APP = 'init_app';
export const CHANGE_BG = 'change_bg';
export const PREVIEW = 'preview';
export const SAVE = 'save';
export const NEW_MODAL = 'new_modal';
export const CHANGE_SIZE = 'change_size';




// WEBPACK FOOTER //
// ./src/redux/actions/types.js